import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { cn } from '../../../utils/class-utils';

@Component({
    selector: 'jjames-card',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div [class]="cardClasses">
      <!-- Header -->
      @if (hasHeader) {
        <div class="px-6 py-4 border-b border-gray-200">
          <ng-content select="[slot=header]"></ng-content>
        </div>
      }
      
      <!-- Content -->
      <div class="px-6 py-4">
        <ng-content></ng-content>
      </div>
      
      <!-- Footer -->
      @if (hasFooter) {
        <div class="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <ng-content select="[slot=footer]"></ng-content>
        </div>
      }
    </div>
  `,
    styles: []
})
export class JJamesCardComponent {
    @Input() shadow: 'none' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
    @Input() padding: 'none' | 'sm' | 'md' | 'lg' = 'md';
    @Input() hasHeader = false;
    @Input() hasFooter = false;

    get cardClasses(): string {
        const baseClasses = 'bg-white rounded-lg border border-gray-200';
        const shadowClasses = this.getShadowClasses();
        const paddingClasses = this.getPaddingClasses();

        return cn(baseClasses, shadowClasses, paddingClasses);
    }

    private getShadowClasses(): string {
        const shadows: Record<string, string> = {
            none: '',
            sm: 'shadow-sm',
            md: 'shadow-md',
            lg: 'shadow-lg',
            xl: 'shadow-xl'
        };
        return shadows[this.shadow];
    }

    private getPaddingClasses(): string {
        if (this.padding === 'none') {
            return '';
        }
        // Padding is handled in template for better control
        return '';
    }
}